import { ContractDto } from '../../../services/dtos/contract.dto';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { useEffect, useRef, useState } from 'react';
import { getRequests } from '../../../services/requests.service';
import { RequestDto } from '../../../services/dtos/request.dto';
import { showAxiosMessageError } from '../../../services/error-message.service';
import ContractRequestsUi from '../../user-interfaces/contract/requests/contract-requests.ui';
import { Paper, Skeleton, Typography } from '@mui/material';
import './contract-request.scss';

/**
 * Fetches and displays contract requests information.
 *
 * @param {object} props - The props containing the contract object.
 * @param {object} props.contract - The contract object containing contract information.
 *
 * @return {React.Component} - The component displaying the contract requests information.
 */
export default function ContractRequests(props: { contract?: ContractDto }): JSX.Element {
    // Snackbar des messages
    const showMessage = useSnackbars();
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [requests, setRequests] = useState<RequestDto[]>();

    // Récupération des demandes à l'ouverture de la page
    useEffect(() => {
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;

        getRequests(props.contract?.['@id'])
            .then(data => {
                setRequests(data);
            })
            .catch(error => {
                console.error('Erreur lors de la récupération des demandes');
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <Paper key={props.contract?.['@id']} className={'container-requests'}>
            {/*Affichage des infos du contrat*/}
            {props.contract?.informations?.abonne && (
                <>
                    <Typography variant={'h5'}>
                        Contrat : {props.contract.informations.abonne.typeContrat} -{' '}
                        {props.contract.informations.abonne.pdiReference}
                    </Typography>
                    {props.contract.adresseCompteur && (
                        <Typography variant={'body1'}>
                            Lieu de consommation :{' '}
                            {props.contract.adresseCompteur?.adresse_complete ||
                                `${props.contract.adresseCompteur?.numero || ''} ${
                                    props.contract.adresseCompteur?.rue || ''
                                }, ${props.contract.adresseCompteur?.code_postal || ''} ${
                                    props.contract.adresseCompteur?.ville || ''
                                }`.trim()}
                        </Typography>
                    )}
                </>
            )}
            {loading ? (
                <Skeleton variant="rectangular" height={250}></Skeleton>
            ) : (
                <ContractRequestsUi requests={requests} onOneContract={true} />
            )}
        </Paper>
    );
}
